import React from "react";
import images from "../../../images";
import { cn } from "../../../Utils/helper";

const Breadcrumb = ({
  breadCrumbTiltle,
  onClickBack,
  className,
  classNameText,
  imagesSubTitle,
}) => {
  return (
    <div
      className={cn(
        `flex flex-col mt-[24px] items-start gap-6 ${
          classNameText ? classNameText : "text-[#253FF6]"
        }   font-bold`,
        className
      )}
    >
      <img
        onClick={onClickBack}
        src={images.ArrowLeftIconGray}
        alt=""
        className="w-6 h-6 cursor-pointer"
      />

      <div className="flex flex-row items-center gap-2">
        {imagesSubTitle && (
          <img src={imagesSubTitle} alt="" className="w-5 h-5 object-cover" />
        )}
        <h4 className="text-[#253FF6] font-[Figtree] text-[24px] font-bold not-italic leading-none">
          {breadCrumbTiltle}
        </h4>
      </div>
    </div>
  );
};

export default Breadcrumb;
